export default __webpack_public_path__ + "static/media/profileImg6.d7e18d14.png";